exports = module.exports = require("../../../../../../node_modules/css-loader/dist/runtime/api.js")(false);
// Imports
var urlEscape = require("../../../../../../node_modules/css-loader/dist/runtime/url-escape.js");
var ___CSS_LOADER_URL___0___ = urlEscape(require("../../../static/images/jhipster_family_member_0.svg"));

// Module
exports.push([module.id, "/* ==========================================================================\r\nMain page styles\r\n========================================================================== */\n.hipster {\n  display: inline-block;\n  width: 100%;\n  height: 497px;\n  background: url(" + ___CSS_LOADER_URL___0___ + ") no-repeat center top;\n  background-size: contain;\n}", ""]);

